import { render, staticRenderFns } from "./DealerList.vue?vue&type=template&id=2ea2686e&scoped=true&"
import script from "./DealerList.vue?vue&type=script&lang=js&"
export * from "./DealerList.vue?vue&type=script&lang=js&"
import style0 from "./DealerList.vue?vue&type=style&index=0&id=2ea2686e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea2686e",
  null
  
)

export default component.exports